module.exports = __webpack_public_path__ + "product/product-step-0b1cd862e289aebf5a52052233f0aef1.webp";